import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import mustBeLogged from '../../components/Must/MustBeLogged.jsx';
import MustBeAdminOrBmOrCompletedFreelance from "../../components/Must/MustBeAdminOrBmOrCompletedFreelance.jsx";
import StrategyFreelanceContainer from './StrategyFreelanceContainer.jsx';
import UserDashboard from './Components/Profil/User/UserDashboard.jsx';

import actions from '../../components/CurrentUserLoader/actions.js';
import conf from '../../../shared/conf.js';
import {isUserAgent, isUserFreelance} from "../../../shared/services/userService.js";
import AgentDashboard from "./Components/Profil/Agent/AgentDashboard.jsx";

class MyDashboardProfileContainer extends Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextProps.endLoadingCurrentUser;
  }

  render() {
    const {currentUser, currentFreelance, endLoadingCurrentUser, ...rest} = this.props;

    if (!endLoadingCurrentUser) {
      return null;
    }

    const isFreelance = isUserFreelance(currentUser)
    const isAgent = isUserAgent(currentUser)

    if (!isFreelance && !isAgent) {
      return null
    }

    if(isFreelance) {
      if(!currentFreelance) {
        return null
      }

      return (
        <StrategyFreelanceContainer
          currentUser={currentUser}
          isOwner={!!currentUser}
          loading={!endLoadingCurrentUser}
          navbar={true}
          link={{
            menu: 'edit-freelance',
            parameters: {
              slug: currentFreelance ? currentFreelance.slug : null,
            },
            search: null,
          }}
          profile={{user: currentUser, freelance: currentFreelance}}
          view={UserDashboard}
          {...rest}
        />
      )
    }

    return <AgentDashboard user={currentUser} navbar={true} locked={true} {...rest} />
  }
}

export default connect(
  (state) => ({
    currentUser: state.currentUser.user,
    currentFreelance: state.currentUser.freelance,
    endLoadingCurrentUser: state.currentUser.endLoading,
  }),
  (dispatch) => bindActionCreators(actions, dispatch)
)(mustBeLogged(MustBeAdminOrBmOrCompletedFreelance(MyDashboardProfileContainer), [conf.accountTypes.freelance,conf.accountTypes.do]));